import React, { useRef, useEffect } from 'react';
import { number, array, func } from 'prop-types';

import * as quizStatus from '@blueberry/constants/quizStatus';

import styles from './QuizNumberList.scss';
const cx = require('classnames/bind').bind(styles);

function QuizNumberList({ currentIndex, quizzes, clickNumber }) {
  const rootElement = useRef(null);
  useEffect(() => {
    const selectedNode = rootElement.current.querySelector(
      `.${styles.selected}`
    );

    const scrollLeft =
      selectedNode.offsetLeft < rootElement.current.offsetWidth
        ? 0
        : selectedNode.offsetLeft;

    rootElement.current.scrollLeft = scrollLeft;
  }, [currentIndex]);

  const renderNumber = (quiz, index) => {
    const isSelect = index === currentIndex;

    return (
      <li
        className={cx(styles.number, {
          selected: isSelect,
          correct: quiz.status === quizStatus.PASS,
          incorrect: quiz.status === quizStatus.FAIL,
        })}
        key={index}
        onClick={clickNumber(index)}
      >
        {index + 1}
      </li>
    );
  };

  return (
    <div className={styles.root} ref={rootElement}>
      <ul className={styles.container}>{quizzes.map(renderNumber)}</ul>
    </div>
  );
}

QuizNumberList.propTypes = {
  clickNumber: func.isRequired,
  currentIndex: number,
  quizzes: array,
};

export default QuizNumberList;



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/QuizBlock/components/QuizNumberList/QuizNumberList.jsx